import React, { useMemo, useState } from 'react';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, Configure, DynamicWidgets } from 'react-instantsearch';
import { searchStateToUrl, urlToSearchState } from '../../helpers/search-url';
import InfiniteHits from './components/InfiniteHits';
import SearchBox from './components/SearchBox';
import RefinementList from './components/RefinementList';
import ClearRefinements from '../Common/ClearRefinements';
import NoResults from './components/NoResults';
import Stats from './components/Stats';
import Sort from './components/Sort';

const algoliaClient = algoliasearch(process.env.ALGOLIA_APP_ID, window.algolia.key);

const INDEX_DEFAULT = 'insights';
const INDEX_SORT_DATE = 'insights_date_desc';

const searchClient = {
    ...algoliaClient,
    search(requests) {
        const newRequests = requests.map((request) => {
            // test for empty string and change request parameter: analytics
            if (!request.params.query || request.params.query.length === 0) {
                request.params.analytics = false;
            }
            return request;
        });
        return algoliaClient.search(newRequests);
    },
};

const InsightSearch = ({ userId }) => {
    const [indexState, setIndexState] = useState(INDEX_DEFAULT);
    const indexWithPrefix = useMemo(() => `${process.env.ENVIRONMENT}_${indexState}`, [indexState]);

    return (
        <InstantSearch
            indexName={indexWithPrefix}
            insights={{
                insightsInitParams: {
                    useCookie: true,
                    userToken: userId || undefined,
                },
            }}
            routing={{
                stateMapping: {
                    stateToRoute(uiState) {
                        const indexUiState = uiState[indexWithPrefix] || {};
                        return searchStateToUrl(indexUiState);
                    },
                    routeToState(routeState) {
                        return {
                            [indexWithPrefix]: urlToSearchState(routeState),
                        };
                    },
                },
            }}
            searchClient={searchClient}
        >
            <Configure hitsPerPage={9} clickAnalytics />
            <SearchBox showLoadingIndicator />

            <div className="cardsListings">
                <div className="cards__sidebar cards__sidebar--insights">
                    <ClearRefinements />
                    <DynamicWidgets fallbackComponent={RefinementList}>
                        <RefinementList attribute="topics" label="Featured Topics" />
                        <RefinementList attribute="categories.title" label="Content Types" />
                    </DynamicWidgets>
                </div>
                <div className="cards__listing">
                    <Sort
                        currentSortOption={indexState === INDEX_SORT_DATE ? 'recent' : 'relevant'}
                        onChangeSort={(newSortOption) => {
                            if (newSortOption === 'recent') {
                                setIndexState(INDEX_SORT_DATE);
                                return;
                            }
                            setIndexState(INDEX_DEFAULT);
                        }}
                    />
                    <Stats />
                    <InfiniteHits />
                    <NoResults />
                </div>
            </div>
        </InstantSearch>
    );
};

export default InsightSearch;
